export default __webpack_public_path__ + "static/media/auction.6298f61e.svg";